import type { Plugin } from 'vue'
import type { MapLibreConfig } from './maplibreUtils'
import { defaultMapLibreConfig } from './maplibreUtils'

export default {
  install: (app, options: MapLibreConfig) => {
    const maplibreConfig = {
      ...defaultMapLibreConfig,
      ...options,
    }

    app.config.globalProperties.maplibre = maplibreConfig
    app.provide('maplibre', maplibreConfig)
  },
} as Plugin
